export const payRateTypeObj = {
    systemCal: 7,
    manualCal: 8,
  };

  export const shiftTypeObj = {
    singleShift:1,
    dailyEnocunter:2,
    multiShift:3,
    repost:4
  };

  export const tenantIdObj = {
    nursesEtc:5003
  };
  
  export const sortOrderObj =  {
    downArrow:"Desc",
    upArrow:"Asc",
    clearFilter:""
  };
  
  export const tiltedColorCode = {
    black:1,
    red:2
  }

  export const pageUrl = {
    correctionPage:'/awaitingcorrection',
    jobCreationPage:'/jobopportunity',
    dailyEncounter:"/daily-encounter-info"
  }